import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { UtilitiesProvider } from '../../providers/utilities';
import { EventData } from '../../providers/event';
import { ENV } from '@app/env';
import { switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as clientSelector from '../../ngrx/reducers/client.reducer';
@Component({
  selector: 'helper-btn-slack',
  templateUrl: 'helper-btn-slack.html'
})

export class HelperBtnSlackComponent implements OnInit, OnChanges {

  public config$: Observable<any>;
  @Input() eventId: string = '--';
  public EventID: string;

  constructor(
    public utilities: UtilitiesProvider,
    public eventData: EventData,
    public store: Store<any>,
  ) {
  }

  public ngOnInit() {
    this.getConfig();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.eventId) {
      this.eventId = changes.eventId.currentValue;
      this.getConfig();
    }
  }

  private getConfig() {
    if (this.eventId) {
      this.config$ = this.eventData
        .getEventInfo(ENV.client, this.eventId)
        .pipe(
          switchMap((eventInfo: any) => {
            if (eventInfo && eventInfo.custom_style === true) {
              return Observable.of(eventInfo);
            }
            return this.store.select(clientSelector.getClient);
          })
        );
    } else {
      this.config$ = this.store.select(clientSelector.getClient);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/helper-btn-slack/helper-btn-slack.ts